export function getAvatarInitials(
  firstName?: string,
  lastName?: string,
  email?: string,
): string {
  let toReturn = 'U';
  if (firstName && lastName) {
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  } else if (email) {
    const emailSplited = email.split('@')[0].split('.');
    toReturn = emailSplited[0].length ? emailSplited[0].charAt(0) : '';
    if (emailSplited.length > 1) {
      toReturn =
        toReturn + emailSplited[1].length ? emailSplited[1].charAt(0) : '';
    }

    return toReturn.length >= 1 ? toReturn : 'U';
  }
  return toReturn;
}
